export default "__VITE_ASSET__d57b9b06__"